let ringtoneCtx = null;
let ringtoneTimer = null;

function getCtx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  return new AC();
}

function beep(ctx, frequency, start, duration, volume) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(volume, start + 0.02);
  gain.gain.setValueAtTime(volume, start + duration - 0.02);
  gain.gain.linearRampToValueAtTime(0, start + duration);
  osc.connect(gain).connect(ctx.destination);
  osc.start(start);
  osc.stop(start + duration + 0.05);
}

export function playRingtone() {
  stopRingtone();
  try {
    const ctx = getCtx();
    ringtoneCtx = ctx;
    const ring = () => {
      if (!ringtoneCtx) return;
      const now = ringtoneCtx.currentTime;
      beep(ringtoneCtx, 440, now, 1.2, 0.35);
      beep(ringtoneCtx, 480, now, 1.2, 0.35);
    };
    ring();
    ringtoneTimer = setInterval(ring, 3000);
  } catch (e) {
    console.error('Ringtone failed:', e);
  }
}

export function stopRingtone() {
  if (ringtoneTimer) clearInterval(ringtoneTimer);
  ringtoneTimer = null;
  if (ringtoneCtx) {
    ringtoneCtx.close().catch(() => {});
    ringtoneCtx = null;
  }
}

export function playMessageTone() {
  try {
    const ctx = getCtx();
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const now = ctx.currentTime;
    beep(ctx, 740, now, 0.12, 0.4);
    beep(ctx, 988, now + 0.15, 0.18, 0.4);
    setTimeout(() => ctx.close().catch(() => {}), 600);
  } catch (e) {
    console.error('Message tone failed:', e);
  }
}
